import { render, staticRenderFns } from "./AvatarsGroup.vue?vue&type=template&id=d96bc56a&scoped=true"
import script from "./AvatarsGroup.vue?vue&type=script&lang=js"
export * from "./AvatarsGroup.vue?vue&type=script&lang=js"
import style0 from "./AvatarsGroup.vue?vue&type=style&index=0&id=d96bc56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96bc56a",
  null
  
)

export default component.exports